import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { Form, FormGroup, Label } from "reactstrap";
import { KI_PERUSAHAAN, KI_KUARTAL, KI_YEAR, KI_TYPE } from "../../constants";
import {
  SelectPerusahaanComponent,
  YearList,
  FinanceTypeList,
  KuartalComponent,
} from "../../component/Utils";

export default (props) => {
  const user = JSON.parse(localStorage.getItem("user")) || {};
  const isAdmin = user.role < 4;
  const dispatch = useDispatch();
  const companies = useSelector(
    (state) => state.perusahaanReducer.listPerusahaan
  );
  const { kuartal, year, type, perusahaan } = useSelector(
    (state) => state.filterKinerja
  );
  React.useEffect(() => {
    const company = isAdmin ? companies.content[0]?.id : user.perusahaan.id;
    dispatch({ type: KI_PERUSAHAAN, data: company });
  }, [companies]);

  const onChange = (type, data) => dispatch({ type, data });

  return (
    <Form className="mb-3">
      <div className="d-md-flex">
        {isAdmin && (
          <FormGroup className="mr-md-3">
            <Label>Perusahaan</Label>
            <SelectPerusahaanComponent
              value={perusahaan}
              onChange={(e, { value }) => onChange(KI_PERUSAHAAN, value)}
              className="form-control"
            />
          </FormGroup>
        )}
        <FormGroup className="mr-md-3">
          <Label>Jenis Laporan</Label>
          <FinanceTypeList
            value={type}
            onChange={(e, { value }) => onChange(KI_TYPE, value)}
            className="form-control"
          />
        </FormGroup>
        <FormGroup className="mr-md-3">
          <Label>Periode</Label>
          <KuartalComponent
            value={kuartal}
            onChange={(e, { value }) => onChange(KI_KUARTAL, value)}
            className="form-control"
          />
        </FormGroup>
        <FormGroup className="mr-md-3">
          <Label>Tahun</Label>
          <YearList
            value={year}
            onChange={(e, { value }) => onChange(KI_YEAR, value)}
            className="form-control"
          />
        </FormGroup>
        
      </div>
    </Form>
  );
};
